export default {
  formId: 'editProfileForm',
  formField: {
    name: 'name',
    email: 'email',
    phone: 'phone',
    cpf: 'cpf',
    rg: 'rg',
    birthDate: 'birthDate',
    profession: 'profession',
    nationality: 'nationality',
    maritalStatus: 'maritalStatus',
    propertyRegime: 'propertyRegime',
    zipcode: 'zipcode',
    street: 'street',
    neighborhood: 'neighborhood',
    city: 'city',
    state: 'state',
    number: 'number',
    complement: 'complement',
    socialName: 'socialName',
    fantasyName: 'fantasyName',
    emailCompany: 'emailCompany',
    phoneCompany: 'phoneCompany',
    sacCompany: 'sacCompany',
    cnpj: 'cnpj',
    pixType: 'pixType',
    pix: 'pix',
    zipcodeCompany: 'zipcodeCompany',
    streetCompany: 'streetCompany',
    neighborhoodCompany: 'neighborhoodCompany',
    cityCompany: 'cityCompany',
    stateCompany: 'stateCompany',
    numberCompany: 'numberCompany',
    complementCompany: 'complementCompany',
  }
};
